module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('iframe', {
    ref: "iframe",
    class: _vm.$style.iframe,
    attrs: {
      "src": _vm.info.iframeSrc,
      "scrolling": "no",
      "allowtransparency": "true",
      "frameborder": "0"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bc7966a4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PlayerFrame.vue
// module id = 182
// module chunks = 0 1